import { GET_CUSTOM_LIST_BY_TYPE_SUCCESS } from "./constants.js"

const initialState = {}

const customListsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_CUSTOM_LIST_BY_TYPE_SUCCESS:
      return {
        ...state,
        [payload?.listType]: payload?.customList,
      }
    default:
      return state
  }
}

export default customListsReducer
